import { Phone } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { BookingForm } from "../components/site/BookingForm";
import { ContactDetails } from "../components/site/ContactDetails";
import { Reveal } from "../components/site/Motion";
import { GhostButton } from "../components/site/Buttons";
import { WhatsAppIcon } from "../components/site/WhatsAppIcon";
import { usePageMeta } from "../components/site/SmoothScroll";
import { FAQ, ProseSection } from "../components/site/SeoContent";
import { BOOK_PROSE, BOOK_FAQ } from "../lib/seoContent";
import { IMAGES, PHONE_TEL, WHATSAPP_URL } from "../lib/site";

export default function Book() {
  usePageMeta(
    "Book an Astrology or Psychic Reading in Calgary | Astrologer & Spiritual Healers",
    "Book your astrology, tarot, psychic or palm reading appointment in Calgary online, or call and WhatsApp us directly."
  );
  return (
    <main data-testid="book-page">
      <PageHero
        testId="book-hero"
        eyebrow="Book an Appointment"
        image={IMAGES.cosmic}
        lines={[{ text: "Reserve your" }, { text: "consultation", className: "italic gold-text" }]}
        intro="Choose a service, a preferred date and time, and we'll reach out to confirm. Prefer to talk first? Call or message us on WhatsApp."
      />
      <section className="px-5 pb-24 sm:px-8 sm:pb-32 lg:px-12">
        <div className="mx-auto grid max-w-[1400px] gap-12 lg:grid-cols-12">
          <Reveal className="border border-[#D4AF37]/20 bg-[#0E081D]/80 p-6 sm:p-10 lg:col-span-7">
            <BookingForm />
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9">
            <h2 className="font-display text-3xl text-white sm:text-4xl">Rather speak to us?</h2>
            <p className="mt-3 text-slate-300">We're happy to answer questions before you book.</p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row lg:flex-col">
              <GhostButton href={PHONE_TEL} testId="book-call-button" icon={Phone}>Call Now</GhostButton>
              <GhostButton href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" testId="book-whatsapp-button" icon={WhatsAppIcon}>WhatsApp Us</GhostButton>
            </div>
            <div className="mt-8">
              <ContactDetails />
            </div>
          </Reveal>
        </div>
      </section>
      <ProseSection testId="book-prose" eyebrow="How Booking Works" title="Your session, arranged with care" paragraphs={BOOK_PROSE} />
      <FAQ testId="book-faq" title="Booking questions" items={BOOK_FAQ} />
    </main>
  );
}
